import styled from '@emotion/styled';
import { Virtuoso } from 'react-virtuoso'; // https://virtuoso.dev
import { casinoColors } from 'src/assets/colors';
import { cmsCategoriesPageHeight } from 'src/components/CmsCasinoManagement/CategoriesPage.style';
import { spin } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';
import { ScrollBarVertical } from 'src/domains/layouts/shared/scrollbar/Scrollbar.style';
import { ContentH3 } from 'src/domains/layouts/shared/typography/Content.style';

export const GamesColumn = styled('div', { label: 'GamesColumn' })``;

export const GamesPageHeaderRow = styled('div', { label: 'GamesPageHeaderRow' })`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
    margin-bottom: 20px;
    padding: 0 8px;
`;

export const GamesPageTitle = styled(ContentH3, { label: 'GamesPageTitle' })`
    margin: 0;
`;

export const LoadingProvidersList = styled('div', { label: 'LoadingProvidersList' })`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`;

export const LoadingProviderChip = styled('div', { label: 'LoadingProviderChip' })`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 999px;
    background: ${casinoColors.paleGrey};
    color: ${casinoColors.coolBlue};
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
`;

export const LoadingProviderSpinner = styled('span', { label: 'LoadingProviderSpinner' })`
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid ${casinoColors.paleGrey};
    border-top-color: ${casinoColors.coolBlue};
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;

export const GamesListVirtualScroll = styled(Virtuoso, { label: 'GamesListVirtualScroll' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    scrollbar-width: thin;
`;

export const GamesContentWrapper = styled(ScrollBarVertical, { label: 'GamesContentWrapper' })`
    background: ${casinoColors.bgColorPage};
    height: ${cmsCategoriesPageHeight};
    margin: 24px 0 0 0;
    padding: 8px 0 0 8px;
`;

export const PreloaderBlock = styled('div', { label: 'PreloaderBlock' })`
    width: 100%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PreloaderBlockFixed = styled('div', { label: 'PreloaderBlockFixed' })`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 248px;
    z-index: 1;
    height: 100%;
`;

export const Loader = styled('div', { label: 'Loader' })`
    border: 10px solid ${casinoColors.paleGrey};
    border-radius: 50%;
    border-top: 10px solid ${casinoColors.coolBlue};
    width: 60px;
    height: 60px;
    animation: ${spin} 2s linear infinite;
`;
